var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "LayoutBase",
    [
      !_vm.$wait.is("fetching preview resource")
        ? [
            _c(
              "section",
              { staticClass: "preview-section" },
              [
                _c(
                  "header",
                  { staticClass: "preview-section__header" },
                  [
                    _c("h2", { staticClass: "h1" }, [_vm._v("Insight")]),
                    _vm._v(" "),
                    _vm.canCompleteStep(1)
                      ? _c(
                          "router-link",
                          {
                            staticClass: "btn",
                            attrs: { to: _vm.stepLink(1) },
                          },
                          [_vm._v("Edit")]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.completedStep(1)
                  ? [
                      _c("h2", [_vm._v(_vm._s(_vm.resource.name))]),
                      _vm._v(" "),
                      _c("ul", { staticClass: "grid post-details" }, [
                        _vm.resource.sectors
                          ? _c(
                              "li",
                              { staticClass: "col-12 detail" },
                              [
                                _c("span", { staticClass: "label" }, [
                                  _vm._v("Sectors"),
                                ]),
                                _vm._v(" "),
                                _vm._l(_vm.resource.sectors, function (sector) {
                                  return _c("span", { staticClass: "sector" }, [
                                    _vm._v(_vm._s(sector.name)),
                                  ])
                                }),
                              ],
                              2
                            )
                          : _vm._e(),
                      ]),
                    ]
                  : _c("p", [_vm._v("Not completed")]),
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "section",
              { staticClass: "preview-section" },
              [
                _c(
                  "header",
                  { staticClass: "preview-section__header" },
                  [
                    _c("h2", { staticClass: "h1" }, [_vm._v("Category")]),
                    _vm._v(" "),
                    _vm.canCompleteStep(2)
                      ? _c(
                          "router-link",
                          {
                            staticClass: "btn",
                            attrs: { to: _vm.stepLink(2) },
                          },
                          [_vm._v("Edit")]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.completedStep(2)
                  ? [
                      _c("ul", { staticClass: "grid post-details" }, [
                        _vm.resource.category
                          ? _c("li", { staticClass: "col-3 detail" }, [
                              _c("span", { staticClass: "label" }, [
                                _vm._v("Category"),
                              ]),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "h3" },
                                [
                                  _c("SvgIcon", {
                                    attrs: { icon: "category" },
                                  }),
                                  _vm._v(
                                    " " + _vm._s(_vm.resource.category.name)
                                  ),
                                ],
                                1
                              ),
                            ])
                          : _vm._e(),
                      ]),
                    ]
                  : _c("p", [_vm._v("Not completed")]),
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "section",
              { staticClass: "preview-section" },
              [
                _c(
                  "header",
                  { staticClass: "preview-section__header" },
                  [
                    _c("h2", { staticClass: "h1" }, [_vm._v("Content")]),
                    _vm._v(" "),
                    _vm.canCompleteStep(3)
                      ? _c(
                          "router-link",
                          {
                            staticClass: "btn",
                            attrs: { to: _vm.stepLink(3) },
                          },
                          [_vm._v("Edit")]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.completedStep(3)
                  ? [
                      _c("ul", { staticClass: "grid post-details" }, [
                        _vm.resource.type
                          ? _c("li", { staticClass: "col-3 detail" }, [
                              _c("span", { staticClass: "label" }, [
                                _vm._v("Content Type"),
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "h3" }, [
                                _vm._v(_vm._s(_vm.resource.type)),
                              ]),
                            ])
                          : _vm._e(),
                      ]),
                      _vm._v(" "),
                      _vm.resource.description
                        ? _c(
                            "div",
                            {
                              staticClass: "card",
                              staticStyle: { "margin-top": "2rem" },
                            },
                            [
                              _c("div", { staticClass: "header" }, [
                                _vm._v("Description"),
                              ]),
                              _vm._v(" "),
                              _c("div", {
                                domProps: {
                                  innerHTML: _vm._s(_vm.resource.description),
                                },
                              }),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.resource.attachments
                        ? _c("div", { staticClass: "card" }, [
                            _c("div", { staticClass: "header" }, [
                              _vm._v("Attachments"),
                            ]),
                            _vm._v(" "),
                            _vm.resource.attachments.length
                              ? _c(
                                  "ul",
                                  { staticClass: "documents" },
                                  _vm._l(
                                    _vm.resource.attachments,
                                    function (doc) {
                                      return _c(
                                        "li",
                                        [
                                          _c("AttachmentDownload", {
                                            attrs: { attachment: doc },
                                          }),
                                        ],
                                        1
                                      )
                                    }
                                  ),
                                  0
                                )
                              : _vm._e(),
                          ])
                        : _vm._e(),
                    ]
                  : _c("p", [_vm._v("Not completed")]),
              ],
              2
            ),
            _vm._v(" "),
            _c("div", { staticClass: "form" }, [
              _c(
                "div",
                { staticClass: "form__group form__group--submit-fixed" },
                [
                  _vm.resource.can.delete
                    ? _c(
                        "button",
                        {
                          directives: [
                            {
                              name: "wait",
                              rawName: "v-wait:disabled",
                              value: [
                                "saving preview resource",
                                "deleting preview resource",
                              ],
                              expression:
                                "['saving preview resource', 'deleting preview resource']",
                              arg: "disabled",
                            },
                          ],
                          staticClass: "btn btn--danger",
                          on: {
                            click: function ($event) {
                              return _vm.showDeleteModal()
                            },
                          },
                        },
                        [_vm._v("\n\t\t\t\t\tDelete Insight\n\t\t\t\t")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "router-link",
                    {
                      directives: [
                        {
                          name: "wait",
                          rawName: "v-wait:disabled",
                          value: "saving preview resource",
                          expression: "'saving preview resource'",
                          arg: "disabled",
                        },
                      ],
                      staticClass: "btn",
                      attrs: {
                        tag: "button",
                        to: {
                          name: "view-document",
                          params: { insight_id: _vm.resource.id },
                        },
                      },
                    },
                    [_vm._v("\n\t\t\t\t\tSave and Leave\n\t\t\t\t")]
                  ),
                  _vm._v(" "),
                  _vm.resource.can.submit
                    ? _c(
                        "button",
                        {
                          directives: [
                            {
                              name: "wait",
                              rawName: "v-wait:disabled",
                              value: "saving preview resource",
                              expression: "'saving preview resource'",
                              arg: "disabled",
                            },
                          ],
                          staticClass: "btn btn--primary btn--no-stretch",
                          on: {
                            click: function ($event) {
                              return _vm.saveResource(2)
                            },
                          },
                        },
                        [_vm._v("\n\t\t\t\t\tPost Insight\n\t\t\t\t")]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ]),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }